import React from "react";
import { Link } from "react-router-dom";
import { BlogItem } from "../../data/blogs";

function Blogcon({ blo }: { blo: BlogItem[] }) {
  return (
    <>
      <div className="flex justify-center">
        <div className="containerbox">
          <div className="w-full grid grid-cols-1 md:grid-cols-2 gap-4">
            {blo.map((elem: BlogItem) => {
              return (
                <div key={elem.id}>
                  <div
                    style={{
                      boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
                      backgroundColor: "#eff6ff",
                    }}
                    className="w-full h-full flex flex-col justify-between rounded-xl p-5 hover:shadow-md transition-shadow"
                  >
                    <div>
                      <div
                        style={{ aspectRatio: 3 / 2 }}
                        className="py-0 w-full mb-3"
                      >
                        <div
                          style={{ backgroundImage: `url(${elem.image})` }}
                          className="w-full h-full mainbanner rounded-md"
                        ></div>
                      </div>
                      {elem.category && (
                        <span className="text-xs font-semibold text-blue-700 bg-blue-100/80 px-2.5 py-0.5 rounded-full mb-2 inline-block">
                          {elem.category}
                        </span>
                      )}
                      <h5 className="text-lg font-bold text-gray-900 mb-2 line-clamp-2">
                        {elem.title}
                      </h5>
                      <p className="mt-0 line-clamp-3 mb-4 text-gray-600 text-sm leading-relaxed">
                        {elem.excerpt}
                      </p>
                    </div>

                    <Link
                      to={`/${elem.slug}`}
                      className="inline-flex items-center space-x-2 text-slate-900 font-bold hover:text-blue-600 transition-colors pt-2"
                    >
                      <div className="flex items-center px-4 py-1.5 rounded-md bg-white border border-gray-200 shadow-xs">
                        <img
                          className="w-8 mr-2"
                          src="../photo/logobanner.png"
                          alt=""
                        />
                        <span className="font-bold text-slate-900 text-sm">
                          Read More
                        </span>
                      </div>
                    </Link>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
}

export default Blogcon;
